import { Link } from "react-router-dom";
import { useTrips } from "../hooks/useTrips";
import { PageBarAction, usePageBar } from "../contexts/PageBarContext";
import { dayKeyOf, formatDayKey } from "../utils/calendarDay";

/** A trip's first or last day — a calendar day, the same wherever it's read. */
function formatTripDay(value: Parameters<typeof dayKeyOf>[0]): string {
  const key = dayKeyOf(value);
  return key ? formatDayKey(key, { year: "numeric", month: "numeric", day: "numeric" }) : "";
}

export function Trips() {
  const { trips, loading } = useTrips();
  usePageBar({ title: "My Trips", showTitle: true });

  if (loading) {
    return <div className="loading">Loading trips...</div>;
  }

  return (
    <div className="page">
      <div className="section-header page-head">
        <h1>My Trips</h1>
        <Link to="/trips/new" className="btn">+ New Trip</Link>
      </div>
      <PageBarAction>
        <Link to="/trips/new" className="btn">+ New</Link>
      </PageBarAction>
      {trips.length === 0 ? (
        <p className="text-muted">No trips yet. Create your first trip to get started!</p>
      ) : (
        <ul className="trip-list">
          {trips.map((trip) => {
            const partyEntries = Object.entries(trip.travelParty || {});
            return (
              <li key={trip.id}>
                <Link to={`/trips/${trip.id}`} className="trip-card">
                  <div className="trip-card-content">
                    <h2>{trip.name}</h2>
                    <p>
                      {formatTripDay(trip.startDate)} — {formatTripDay(trip.endDate)}
                    </p>
                  </div>
                  {partyEntries.length > 0 && (
                    <div className="trip-card-avatars">
                      {partyEntries.map(([key, member]) => (
                        <div key={key} className="travel-party-avatar" title={member.displayName}>
                          {member.avatarUrl ? (
                            <img src={member.avatarUrl} alt={member.displayName} />
                          ) : (
                            <span>{member.displayName.charAt(0).toUpperCase()}</span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
